import { Injectable } from "@nestjs/common";
import { SpecSheetDto } from "./spec-sheet.dto";
import { SpecSheet } from "./spec-sheet.entity";

@Injectable()
export class SpecSheetAdpater{
    public convertDtoToEntity(specSheetDto:SpecSheetDto,isUpdate : boolean = false):SpecSheet{
        console.log(isUpdate)
        const specsheet = new SpecSheet();
        specsheet.customerId=specSheetDto.customerId;
        specsheet.brandId=specSheetDto.brandId;
        specsheet.skuCodeId=specSheetDto.skuCodeId;
        specsheet.fileName=specSheetDto.fileName;
        specsheet.filePath=specSheetDto.filePath;

        specsheet.isActive=specSheetDto.isActive==undefined?true:specSheetDto.isActive;
        if (isUpdate) {
            console.log(specsheet,'&&&')
            specsheet.specSheetId=specSheetDto.specSheetId;
            specsheet.fileName=specSheetDto.fileName;
            specsheet.filePath=specSheetDto.filePath;
            specsheet.updatedUser = specSheetDto.updatedUser;

        } else {
            specsheet.isActive = true;
            specsheet.createdUser = specSheetDto.createdUser;
        }
       return specsheet;
    }
    public convertEntityToDto(specsheetobject:SpecSheet):SpecSheetDto{
        const specheetdto=new SpecSheetDto;
        console.log(specheetdto,'##')
        specheetdto.specSheetId=specsheetobject.specSheetId;
        specheetdto.customerId=specsheetobject.customerId;
        specheetdto.brandId=specsheetobject.brandId;
        specheetdto.skuCodeId=specsheetobject.skuCodeId;
        specheetdto.fileName=specsheetobject.fileName;
        specheetdto.filePath=specsheetobject.filePath;
        specheetdto.isActive = specsheetobject.isActive;
        specheetdto.createdAt = specsheetobject.createdAt;
        specheetdto.updatedAt = specsheetobject.updatedAt;
        specheetdto.createdUser = specsheetobject.createdUser;
        specheetdto.updatedUser = specsheetobject.updatedUser;
        specheetdto.versionFlag = specsheetobject.versionFlag;
     return specheetdto;

    }


}